module.exports = function() {
  return new Worker(__webpack_public_path__ + "38f8261f862102922822.worker.js");
};